document.addEventListener('DOMContentLoaded', (event) => {

	const sections = document.querySelectorAll('section')

	if(sections) {
		if (sections[0].classList.contains('lead') && sections[1].classList.contains('text-only')) {
			const lead_section = document.querySelector('.lead')

			if(lead_section) {
				lead_section.classList.add('pb-none')
			}
		}
	}
})